import { GOVGR_LINK } from "../../conf/styles/GovGrLink";

const GovGrLink = ({ text = "", ...props }) => {
  return (
    <a className={GOVGR_LINK} {...props}>
      {text}
    </a>
  );
};

export default GovGrLink;
